















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DocIcon from '../icons/DocIcon.vue';
import { GlobalBusNames } from '@/templates/DataNames';
import GlobalBus from '@/plugins/GlobalBus';
import Clipboard from '@/plugins/Clipboard';

@Component({
  components: {
    DocIcon,
  },
})
export default class CopyUrlButton extends Vue {
  @Prop({ default: '' }) anchor: string;
  private isCopied = false;
  private isMobile = false;

  copyToClipboard() {
    this.isCopied = true;
    Clipboard.copy(
      `${window.location.origin}${window.location.pathname}${this.anchor ? `#${this.anchor}` : ''}`
    );
    GlobalBus.emit(GlobalBusNames.COPIEDTOCLIPBOARD, this.anchor);
    setTimeout(() => (this.isCopied = false), 2000);
  }

  mounted() {
    GlobalBus.on(GlobalBusNames.COPIEDTOCLIPBOARD, (val: string) => {
      if (this.anchor !== val) this.isCopied = false;
    });
    GlobalBus.on(GlobalBusNames.ISMOBILE, (isMobile: boolean) => (this.isMobile = isMobile));
  }

  beforeDestroy() {
    GlobalBus.off(GlobalBusNames.COPIEDTOCLIPBOARD);
  }
}
